<style scoped>
    @import "./index.css";
    #tabBar {
        margin-bottom: 15px;
    }
    .select-type li {
        width: 145px;
        height: 160px;
    }
    .select-type img {
        width: 90px;
        height: 90px;
        text-align:center
    }
    .select-type p {
        width: 120px;
        height: 20px;
    }
    #sb-list .ivu-card-body {
        min-height: 180px;
    }

</style>
<template>
    <div style="position: relative">

        <Spin v-if="preloading" size="large" fix>
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div style="font-size: 12px">正在获取场景...</div>
        </Spin>

        <div id="layout-container" >
            <!--tabBar-->
            <Row id="tabBar" type="flex" align="middle" justify="space-between">
                <Col>
                <Button style=" color: #28EDF8; background-color: #074A7F" type="text" @click="addCat" icon="md-add" >添加场景分类</Button>
                <Button style=" color: #28EDF8; background-color: #074A7F;margin-left: 10px" type="text" @click="add" icon="md-add" >添加场景</Button>
                </Col>
            </Row>
            <!--tabBar end-->
            <!--列表-->
            <div v-if="!preloading">
                <div v-if="list.length <= 0"
                     style=" height:calc(100vh - 200px); font-size: 14px; color:#ddd; display: flex; align-items: center; justify-content: center">
                    <div style="line-height: 180%; text-align: center">
                        <Icon style="font-size: 50px; color:#ddd" type="ios-paper-plane-outline"/>
                        <br/>暂无数据
                    </div>
                </div>

                <Row v-else id="sb-list" class-name="tf-row" type="flex" align="top" justify="space-between">
                    <Col  :md="12" :xs="24" v-for="(item,index) in list" :key="index" class-name="item" >
                    <Card  id="myCard" :bordered="false" :dis-hover="true">
                        <div class="myCard-head tf-center" slot="title">
                            <span class="myCard-title">{{item.sceneCatName}}</span>
                            <div>
                                <Button @click="editName(item.sceneCatName,item.sceneCatId)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-create"
                                        title="编辑场景分类名称" size="small" type="success"></Button>
                                <Button @click="delSceneCat(item.sceneCatId)"
                                        style="position: relative; margin-left:5px; top:-1px" icon="md-trash"
                                        title="删除场景分类" size="small" type="error"></Button>
                            </div>
                        </div>
                        <div class="myCard-con web-gailan overview">
                            <ul v-if="item.sceneList.length > 0" class="select-type">
                                <li  v-for="(vo,index2) in item.sceneList" :key="index2" :class="[vo.sceneOpen == 2 ? 'gray' : '']" style="position:relative">
                                    <div class="tthui">
                                        <img @click="edit(vo)" :src="vo.sceneImg ? imgSrc+vo.sceneImg : nopic">
                                        <p class="limit-1-line" @click="edit(vo)">{{vo.sceneName}}</p>
                                    </div>
                                    <div class="ttbtn" style="padding: 0; border:none">
                                        <ButtonGroup style="padding: 0; border:none;">
                                            <Button @click="onOpen(vo.sceneId,vo.sceneOpen)" :type="vo.sceneOpen == 2 ? 'primary' : 'dashed'" size="small" icon="md-power" :title="vo.sceneOpen == 2 ? '开启场景' : '关闭场景'"></Button>
                                            <Button @click="onDel(vo.sceneId)" size="small" type="error" icon="ios-trash" title="删除场景"></Button>
                                        </ButtonGroup>
                                    </div>
                                </li>
                            </ul>
                            <div v-else style="position: absolute; color: #ccc; top:40px; bottom: 0; left:0; right:0;"
                                 class="tf-flex tf-flex-middle tf-flex-center">暂无数据
                            </div>
                        </div>
                    </Card>
                    </Col>
                </Row>
            </div>

            <!--右侧弹出窗口-->
            <Drawer :title="winTitle" width="750" v-model="show" @on-close="onClose">
                <!--<dscjAdd  v-if="type === 1" @close="onClose"></dscjAdd>-->
                <!--<dscjEdit v-if="type === 2" :itemval="itemVal" @close="onClose"></dscjEdit>-->
                <dscjAdd  v-if="type === 1" :itemval="itemVal" @close="onClose"></dscjAdd>
                <dscjAdd  v-if="type === 2" :itemval="itemVal" @close="onClose"></dscjAdd>
            </Drawer>
        </div>

    </div>
</template>

<script>

    import nopic from '@/assets/img/no_pic.png';
    import dscjAdd from "./add";

    export default {
        name: "add",
        components: {
            dscjAdd
        },
        data() {
            return {
                imgSrc:this.$func.imgSrc,
                //图片
                nopic:nopic,

                //侧边弹出+步骤索引
                show:false,
                type:0, //1添加 2编辑
                winTitle: "",

                //列表
                list: [],

                //修改
                itemVal:'',

                //添加/编辑预加载数据
                preloading:true,

            };
        },
        computed:{
            areaId(){
                return this.$store.state.app.areaId
            }
        },
        watch:{
            areaId(){
                this.getData();
            }
        },
        created(){
            let that = this;
            //有数据执行
            var _time = setInterval(function(){
                if(that.$store.state.app.areaId){
                    clearInterval(_time);
                    that.getData();
                }
            },100)
        },
        methods: {
            getData(){
          var that = this;
          that.preloading = true;
          that.$func.ajax('listScene',{
              token:that.$func.getToken(),
              areaId:that.$store.state.app.areaId
          },function(r){
              if(!r.statusCode){
                  that.$func.msg(r.message,'error');
              }else
              {
                  console.log('**********获取场景*************');
                  console.log(r);
                  that.list=r.type;
                  that.preloading = false;
              }
          })
     },
            //删除场景分类
            delSceneCat(sceneCatId){
                const that = this;
                that.$Modal.confirm({
                    title: '确定删除该场景分类吗？',
                    content: '将会把所有区域下该场景分类下的所有场景删除，请您知晓！',
                    onOk: () => {
                        that.$func.ajax('delSceneCat', {
                            sceneCatId:sceneCatId
                        }, function (r) {
                            if (!r.statusCode) {
                                that.$func.msg(r.message, 'error');
                            } else {
                                that.$Message.success('删除成功');
                                that.getData();
                            }
                        })
                    }
                })
            },

            editName(name,sceneCatId){
                const that = this;
                var newVal = '';
                that.$Modal.confirm({
                    title:'编辑场景分类名称',
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: name,
                                autofocus: true,
                                placeholder: '请输入场景分类名称',
                                maxlength:10
                            },
                            on: {
                                input: (val) => {
                                    newVal = val
                                }
                            }
                        })
                    },
                    onOk: () => {
                        that.$func.ajax('custSceneCatSave',{
                            sceneCatId:sceneCatId,
                            sceneCatName:newVal || name
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$store.commit('setSlideName',{
                                    id:'',
                                    name:newVal
                                })
                                that.$Message.success('修改成功');
                                that.getData();
                            }
                        })
                    }
                })
            },
            //关闭侧滑
            onClose(){
                this.type = 0
                this.show = false;
                this.getData();
            },
            //新增场景分类
            addCat() {
                const that = this;
                var newVal = '';
                that.$Modal.confirm({
                        title: '添加场景分类',
                        render: (h) => {
                        return h('Input', {
                            props: {
                                value: name,
                                autofocus: true,
                                placeholder: '请输入场景分类名称',
                                maxlength: 10
                            },
                            on: {
                                input: (val) => {
                                newVal = val
                                }
                            }
                         })
                        },
                onOk: () => {
                    that.$func.ajax('custSceneCatSave', {
                        sceneCatName: newVal
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message, 'error');
                        } else {
                            that.$Message.success('添加成功');
                            that.getData();
                        }
                    })
                }
            })
            },

            //新增
            add() {
                const vm = this;
                vm.itemVal = '';
                vm.type = 1;
                vm.winTitle = "添加场景";
                vm.show = true;
            },
            //编辑
            edit(vo) {
                const vm = this;
                vm.itemVal = vo;
                vm.type = 2;
                vm.winTitle = "编辑场景 - "+vm.itemVal.sceneName;
                vm.show = true;
            },
            //删除
            onDel(id) {
                const that = this;
                that.$Modal.confirm({
                    title: '系统提示',
                    content: '确定删除吗？',
                    onOk: () => {
                        that.$func.ajax('sceneDelete',{
                            sceneId:id,
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$Message.success('删除成功');
                                that.getData();
                            }
                        })
                    }
                })
            },
            //开启
            onOpen(id,sceneOpen){
                const that = this;
                that.$Modal.confirm({
                    title: '系统提示',
                    content: sceneOpen==2 ? '确定开启场景吗？':'确定关闭场景吗？',
                    onOk: () => {
                        if(sceneOpen==2){
                            sceneOpen=1;
                        }else {
                            sceneOpen=2;
                        }
                        that.$func.ajax('sceneOpenOrClose',{
                            sceneId:id,
                            sceneOpen:sceneOpen
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$Message.success(r.message);
                                that.getData();
                            }
                        })
                    }
                })
            }
        }
    };
</script>

